import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_PREFIX } from 'utils/constants';

const BrandDetailsIndex = () => {
  const navigate = useNavigate();
  const { brand_id } = useParams();
  useEffect(() => {
    navigate(`${ROUTE_PREFIX.FOOD}/brand/${brand_id}/details`, { replace: true });
  }, []);

  return <div />;
};

export default BrandDetailsIndex;
